import  "../css/card.css";

export default function Card({ title, actions, children, height, width,clickable,dimmed }) {
    const cardStyle = {
      height: height || "auto",
      width: width || "100%",
    };
    
    return (
      <div className={`${clickable ? 'card clickable' : 'card'} ${dimmed ==="Y" ? 'dimmed-card' : ''} ${dimmed ==="N" ? 'highlighted-card' : ''}`} style={cardStyle}>
        {/* CARD HEADER */}
        <div className={`card-header ${dimmed === "Y"  ? 'dimmed-card-header' : ''}`}>
          <h2 className="card-title">{title}</h2>
          {actions && <div className="card-actions">{actions}</div>}
        </div>
  
        {/* CARD BODY */}
        <div className={`card-body ${dimmed ? 'dimmed-card-body' : ''}`}>
          {children}
        </div>
      </div>
    );
  }
  
  